import { RECORD_FAMILY_TRAITS } from "@/features/forms/family-traits";
import type { ViewedRecord } from "@/features/forms/shared/record/viewed-record";
import type {
  RecordFamilyTraits,
  RecordSubjectKind,
} from "@/features/forms/shared/record/record-family";
import {
  CORPORATION_CLIENT_ENTITY,
  INDIVIDUAL_CLIENT_ENTITY,
} from "@/shared/events/entity-invalidation";

interface FrontendContextEntity {
  id: string;
  type: string;
}

export interface FrontendTurnContext {
  viewed_section?: string;
  entities: FrontendContextEntity[];
}

export function recordFrontendContext(
  record: ViewedRecord | null,
  viewedPage: string | null,
): FrontendTurnContext | null {
  if (record === null) return null;
  const formEntity = publishedFormEntity(RECORD_FAMILY_TRAITS[record.family]);
  const formId = sendable(record.recordId);
  const clientId = sendable(record.subject?.clientLinkId ?? null);

  const entities: FrontendContextEntity[] = [];
  if (formId && formEntity) entities.push({ id: formId, type: formEntity });
  if (clientId && record.subject) {
    entities.push({ id: clientId, type: CLIENT_ENTITY[record.subject.kind] });
  }
  if (entities.length === 0) return null;

  const section = sendable(viewedPage);
  return section ? { viewed_section: section, entities } : { entities };
}

export function publishedFormEntity(traits: RecordFamilyTraits): string | null {
  return traits.kind === "sign_document" ? null : traits.entity;
}

function sendable(raw: string | null): string | null {
  const text = (raw ?? "").trim();
  if (!text || text.length > MAX_HINT) return null;
  return text;
}

const MAX_HINT = 200;

const CLIENT_ENTITY: Record<RecordSubjectKind, string> = {
  individual: INDIVIDUAL_CLIENT_ENTITY,
  corporation: CORPORATION_CLIENT_ENTITY,
};
